module.exports = __webpack_public_path__ + "files/367c209e682dbadd6778a345e7796d53.png";